import type { ModuleKey } from '@/utils/constants/navigationLabels'
import { MODULE_ROUTES, TAB_LABELS } from '@/utils/constants/navigationLabels'

// Ubica el módulo al que pertenece una ruta y devuelve los segmentos que siguen a su ruta base.
export const parseAdminPath = (pathname: string) => {
  const moduleKey = (Object.keys(MODULE_ROUTES) as ModuleKey[]).find(
    key => pathname === MODULE_ROUTES[key] || pathname.startsWith(`${MODULE_ROUTES[key]}/`)
  )

  if (!moduleKey) return null

  return {
    moduleKey,
    basePath: MODULE_ROUTES[moduleKey],
    rest: pathname.slice(MODULE_ROUTES[moduleKey].length).split('/').filter(Boolean)
  }
}

export const getTabLabel = (moduleKey: ModuleKey, tab: string): string | undefined => {
  const moduleTabs: Record<string, string> | undefined = Object.hasOwn(TAB_LABELS, moduleKey)
    ? TAB_LABELS[moduleKey as keyof typeof TAB_LABELS]
    : undefined

  return moduleTabs && Object.hasOwn(moduleTabs, tab) ? moduleTabs[tab] : undefined
}
